import { Tree, Tooltip, Modal, Spin, Button } from "antd";
import WeaInput from "../base/wea-input-normal";
import isEqual from "lodash/isEqual";
import isArray from "lodash/isArray";
import isEmpty from "lodash/isEmpty";
import trim from "lodash/trim";
import cloneDeep from "lodash/cloneDeep";
import isString from "lodash/isString";
import random from "lodash/random";
import forEach from "lodash/forEach";
import findIndex from "lodash/findIndex";
import uniq from "lodash/uniq";
import isFunction from "lodash/isFunction";
import "./index.less";
import middleware from "../../middleware";
import WeaLocaleProvider from "../wea-locale-provider";
import WeaAvatar from "../wea-avatar";

const getLabel = WeaLocaleProvider.getLabel;
const confirm = Modal.confirm;
const TreeNode = Tree.TreeNode;

const newKey = "ADD_NEW_NODE_KEY";

const objToArray = obj => {
  if (!isArray(obj)) {
    let arr = [];
    arr.push(obj);
    obj = arr;
  }
  return cloneDeep(obj);
};

let count = 0;

class WeaTree extends React.Component {
  static defaultProps = {
    checkable: false, // 显示checkbox多选
    hasRadio: false, // radio 单选
    loadAll: false, // 默认异步加载
    showCheckStrictly: false, // 父子节点关联btn 默认隐藏
    noCache: false, // 每次展开节点是否接口
    addToLast: false //添加在最后一个节点
  };
  constructor(props) {
    super(props);
    this.state = {
      datas: props.datas ? objToArray(props.datas) : [],
      checkStrictly: props.checkStrictly || false,
      spinning: false,
      radioCheckedKey: props.radioCheckedKey || "",
      expandedKeys: props.expandedKeys || [],
      selectedKeys: props.selectedKeys || [],
      checkedKeys: props.checkedKeys || []
    };
    this.treeMap = {};
    [
      "onExpand",
      "onSelect",
      "onCheck",
      "onRadioCheck",
      // "onDoubleClick",
      "loadData",
      "onDrop"
    ].forEach(f => (this[f] = this[f].bind(this)));
  }
  componentWillReceiveProps(nextProps) {
    let {
      datas,
      radioCheckedKey,
      expandedKeys,
      selectedKeys,
      checkedKeys,
      checkStrictly
    } = this.state;
    if (!isEqual(this.props.datas, nextProps.datas)) {
      datas = cloneDeep(objToArray(nextProps.datas));
      this.setState({ datas });
    }
    if (
      "checkStrictly" in nextProps &&
      !isEqual(checkStrictly, nextProps.checkStrictly)
    ) {
      checkStrictly = nextProps.checkStrictly;
      this.setState({ checkStrictly });
    }
    if (
      "radioCheckedKey" in nextProps &&
      !isEqual(radioCheckedKey, nextProps.radioCheckedKey)
    ) {
      radioCheckedKey = nextProps.radioCheckedKey;
      this.setState({ radioCheckedKey });
    }
    if (
      "expandedKeys" in nextProps &&
      !isEqual(expandedKeys, nextProps.expandedKeys)
    ) {
      expandedKeys = nextProps.expandedKeys;
      this.setState({ expandedKeys });
    }
    if (
      "selectedKeys" in nextProps &&
      !isEqual(selectedKeys, nextProps.selectedKeys)
    ) {
      selectedKeys = nextProps.selectedKeys;
      this.setState({ selectedKeys });
    }
    if (
      "checkedKeys" in nextProps &&
      !isEqual(checkedKeys, nextProps.checkedKeys)
    ) {
      checkedKeys = nextProps.checkedKeys;
      this.setState({ checkedKeys });
    }
  }
  loadData(treeNode) {
    const { props } = this;
    const { loadData, noCache } = this.props;
    if (loadData && (noCache || !treeNode.props.data.isLoad)) {
      return loadData(cloneDeep(treeNode.props.data), this).then(data => {
        const { datas } = this.state;
        treeNode.props.data.children = data.datas;
        this.setState({ datas });
        props.onDatasChange && props.onDatasChange(datas);
      });
    } else {
      return new Promise(resolve => {
        resolve();
      });
    }
  }
  onDrop(e) {
    const { datas } = this.state;
    const { props } = this;
    const { dragNodesKeys, node } = e;
    let dragNode;
    if (!isEmpty(dragNodesKeys)) {
      dragNode = this.treeMap[dragNodesKeys.pop()];
    }
    const targetNode = this.treeMap[node.props.eventKey];
    if (dragNode && !dragNode.dragDisabled) {
      let dragNodeClone = cloneDeep(dragNode);
      delete dragNodeClone.isRoot;
      delete dragNodeClone.parentTreeKey;
      let list;
      if (targetNode.isRoot) {
        list = datas;
        dragNodeClone.isRoot = true;
      } else {
        list = this.treeMap[targetNode.parentTreeKey].children;
        dragNodeClone.parentTreeKey = targetNode.parentTreeKey;
      }
      let idx = findIndex(list, l => l.treeKey === targetNode.treeKey);
      list.splice(idx + 1, 0, dragNodeClone); // add node
      // let dragList;
      // if (dragNode.isRoot) {
      //   dragList = datas;
      // } else {
      //   dragList = this.treeMap[dragNode.parentTreeKey].children;
      // }
      // idx = findIndex(dragList, (l) =>l.treeKey === dragNode.treeKey);
      // dragList.splice(idx, 1); // delete node
      dragNode.deleted = true;
      this.setState({ datas }, () => {
        props.onDrag && props.onDrag(dragNode, targetNode, datas);
      });
    }
  }
  onExpand(ks, e) {
    const { props } = this;
    let ids = [],
      nodeids = [],
      datas = [];
    ks &&
      ks.forEach(k => {
        const target = this.treeMap[k];
        if (target && target.treeKey == k) {
          ids.push(target.id);
          target.nodeid && nodeids.push(target.nodeid);
          datas.push(target);
        }
      });
    ids = uniq(ids);
    nodeids = uniq(nodeids);
    this.setState({ expandedKeys: !isEmpty(nodeids) ? nodeids : ids });
    props.onExpand && props.onExpand(ids, nodeids, datas, e);
  }
  onSelect(ks, e) {
    if (isEmpty(ks)) return; // 不支持取消选中
    const { props } = this;
    let ids = [],
      nodeids = [],
      datas = [];
    ks &&
      ks.forEach(k => {
        const target = this.treeMap[k];
        if (target && target.treeKey == k) {
          ids.push(target.id);
          target.nodeid && nodeids.push(target.nodeid);
          datas.push(target);
        }
      });
    ids = uniq(ids);
    nodeids = uniq(nodeids);
    this.setState({ selectedKeys: !isEmpty(nodeids) ? nodeids : ids });
    props.onSelect && props.onSelect(ids, nodeids, datas, e);
  }
  onCheck(ks, e) {
    const { props } = this;
    let ids = [],
      nodeids = [],
      datas = [];
    ks &&
      ks.forEach(k => {
        const target = this.treeMap[k];
        if (target && target.treeKey == k) {
          ids.push(target.id);
          target.nodeid && nodeids.push(target.nodeid);
          datas.push(target);
        }
      });
    ids = uniq(ids);
    nodeids = uniq(nodeids);
    this.setState({ checkedKeys: !isEmpty(nodeids) ? nodeids : ids });
    // 点击check 展开节点 考虑到异步的case 暂时不开放功能
    // let expandedKeys = this.getExpandedKeys();
    // expandedKeys = uniq(expandedKeys.concat(ks));
    // this.onExpand(expandedKeys);
    props.onCheck && props.onCheck(ids, nodeids, datas, e);
  }
  onRadioCheck(key) {
    const { props } = this;
    this.setState({
      radioCheckedKey: this.treeMap[key].nodeid || this.treeMap[key].id
    });
    props.onRadioCheck &&
      props.onRadioCheck(
        this.treeMap[key].id,
        this.treeMap[key].nodeid,
        this.treeMap[key]
      );
  }
  // onDoubleClick(key) {
  //   const { props } = this;
  //   if (this.isCheckboxDisable(this.treeMap[key])) return;
  //   props.onDoubleClick && props.onDoubleClick([this.treeMap[key]]);
  // }
  focus() {
    setTimeout(() => {
      const dom = $(this.refs.input.refs.input.refs.input);
      const t = dom.val();
      setTimeout(() => {
        dom
          .val("")
          .focus()
          .val(t);
      }, 10);
    }, 10);
  }
  addRootNode() {
    const { props } = this;
    const { datas, expandedKeys } = this.state;
    const target = {
      name: "",
      displayType: "add",
      isRoot: true,
      treeKey: newKey
    };
    this.treeMap[newKey] = cloneDeep(target);
    props.addToLast ? datas.push(target) : datas.unshift(target);
    this.setState({ datas }, () => {
      this.focus();
    });
    props.onDatasChange && props.onDatasChange(datas);
  }
  opsHandler(item, ops) {
    const { props } = this;
    const { datas, expandedKeys } = this.state;
    let passCheck = true;
    if (props.onOpsCheck) {
      passCheck = props.onOpsCheck(ops.type, item);
      if (passCheck == false) {
        return;
      }
    }
    if (ops.type == "add") {
      if (props.addHandler) {
        props.addHandler(item);
      } else {
        if (!this.treeMap[newKey]) {
          const target = {
            name: "",
            displayType: "add",
            parentTreeKey: item.treeKey,
            treeKey: newKey
          };
          if (expandedKeys.indexOf(item.treeKey) == -1) {
            expandedKeys.push(item.treeKey);
            this.onExpand(expandedKeys);
          }
          const { loadData, noCache, addToLast } = this.props;
          // 判断有子节点先请求数据
          if (
            (item.isParent || item.haschild) &&
            (isEmpty(item.children) || noCache) &&
            loadData
          ) {
            this.setState({ spinning: true });
            loadData(cloneDeep(item), this).then(data => {
              item.children = data.datas || [];
              addToLast
                ? item.children.push(target)
                : item.children.unshift(target);
              this.treeMap[newKey] = cloneDeep(target);
              this.setState({ datas, spinning: false }, () => {
                this.focus();
              });
              props.onDatasChange && props.onDatasChange(datas);
            });
          } else {
            item.isParent = true;
            if (item.children && isArray(item.children)) {
              addToLast
                ? item.children.push(target)
                : item.children.unshift(target);
            } else {
              item.children = [target];
            }
            this.treeMap[newKey] = cloneDeep(target);
            this.setState({ datas }, () => {
              this.focus();
            });
            props.onDatasChange && props.onDatasChange(datas);
          }
        }
      }
      return;
    }
    if (ops.type == "edit") {
      if (props.editHandler) {
        props.editHandler(item);
      } else {
        this.treeMap[item.treeKey].displayType = "edit";
        this.setState({ datas }, () => {
          this.focus();
        });
        props.onDatasChange && props.onDatasChange(datas);
      }
      return;
    }
    const _this = this;
    if (ops.type == "delete") {
      if (props.deleteHandler) {
        props.deleteHandler(item);
      } else {
        confirm({
          title:
            props.deleteConfirmText ||
            getLabel("385830", `确认要删除“$s”吗？`).replace(/\$s/, item.name),
          onOk() {
            _this.deleteHandler(item);
          }
        });
      }
      return;
    }
    props.opsHandler && props.opsHandler(item, ops);
  }
  editHandler(v, item) {
    const { props } = this;
    const { datas } = this.state;
    if (trim(v)) {
      let beforeName = item.name;
      item.name = v;
      this.setState({ spinning: true });
      props.onEdit &&
        props.onEdit(v, item).then(
          data => {
            delete item.displayType;
            isFunction(props.validate) &&
              !props.validate(item) &&
              (item.name = beforeName);
            this.setState({ datas, spinning: false });
            props.onDatasChange && props.onDatasChange(datas);
          },
          error => {
            item.name = beforeName;
            delete item.displayType;
            this.setState({ datas, spinning: false });
            props.onDatasChange && props.onDatasChange(datas);
          }
        );
    } else {
      delete item.displayType;
      this.setState({ datas });
      props.onDatasChange && props.onDatasChange(datas);
    }
  }
  addHandler(v, item) {
    const { props } = this;
    const { datas } = this.state;
    if (trim(v)) {
      this.setState({ spinning: true });
      item.name = v;
      const params = item.isRoot ? [v] : [v, this.treeMap[item.parentTreeKey]];
      props.onAdd &&
        props.onAdd(...params).then(
          data => {
            forEach(data, (v, k) => {
              item[k] = v;
            });
            delete item.displayType;
            delete item.treeKey;
            isFunction(props.validate) &&
              !props.validate(item) &&
              this.deleteHandler(item);
            this.setState({ datas, spinning: false });
            props.onDatasChange && props.onDatasChange(datas);
          },
          error => {
            item.deleted = true;
            this.setState({ datas, spinning: false });
            props.onDatasChange && props.onDatasChange(datas);
          }
        );
    } else {
      item.deleted = true;
      this.setState({ datas });
      props.onDatasChange && props.onDatasChange(datas);
    }
    delete this.treeMap[newKey];
  }
  deleteHandler(item) {
    const { props } = this;
    const { datas } = this.state;
    props.onDelete && props.onDelete(item);
    item.deleted = true;
    this.setState({ datas });
    props.onDatasChange && props.onDatasChange(datas);
  }
  getIcon(cof) {
    if (cof.icon) return cof.icon;
    if (cof.type == "delete") {
      return "icon-coms-delete";
    }
    if (cof.type == "edit") {
      return "icon-coms-edit";
    }
    if (cof.type == "add") {
      return "icon-coms-plus";
    }
  }
  getName(cof) {
    if (cof.name) return cof.name;
    if (cof.type == "delete") {
      return getLabel("91", "删除");
    }
    if (cof.type == "edit") {
      return getLabel("26473", "编辑");
    }
    if (cof.type == "add") {
      return getLabel("611", "添加");
    }
  }
  renderOps(item) {
    const { ops, ecId, deleteText } = this.props;
    if (ops || item.ops) {
      const os = item.ops || ops;
      return (
        <div className="ops-wrapper inline-block">
          {os.map((o, idx) => (
            <Tooltip
              ecId={`${ecId}_Tooltip@pgvr3f`}
              placement="bottom"
              title={this.getName(o)}
            >
              <i
                ecId={`${ecId}_i@8ekrbe`}
                className={`${this.getIcon(o)} ops-icon`}
                onClick={e => {
                  e.preventDefault();
                  e.stopPropagation();
                  this.opsHandler(item, o);
                }}
              />
            </Tooltip>
          ))}
        </div>
      );
    }
  }
  renderTitle(item) {
    const {
      renderNode,
      renderItem,
      operations,
      onDoubleClick,
      ecId
    } = this.props;
    let title = (
      <div
        className="text-elli"
        style={{ paddingRight: 25 }}
        title={item.title || item.name}
      >
        {item.icon && (
          <i className={item.icon} style={{ marginRight: "5px" }} />
        )}
        {item.displayName || item.name}
      </div>
    );
    if (item.displayType == "portrait") {
      let requestParams;
      try {
        if (item.requestParams) {
          requestParams = JSON.parse(item.requestParams);
        }
      } catch (e) {}
      title = (
        <div className="text-elli" style={{ height: 30 }} key={item.id}>
          {/* <img
            style={{ width: 30, height: 30, borderRadius: 15, padding: "1px" }}
            src={item.icon || item.img}
            alt="portrait"
          /> */}
          <WeaAvatar
            ecId={`${ecId}_WeaAvatar@0h4iwg`}
            style={{ width: 30, height: 30, borderRadius: 15, padding: "1px" }}
            userId={item.id}
            requestParams={requestParams}
          />
          <span
            style={{ paddingLeft: 10, verticalAlign: "top" }}
            title={item.displayName || item.name}
          >
            {item.displayName || item.name}
          </span>
        </div>
      );
    }
    if (renderNode) {
      title = renderNode(item);
    }
    if (renderItem) {
      title = renderItem(item);
    }
    title = (
      <div
        ecId={`${ecId}_div@kpc2fg`}
        class="wea-tree-node-wrapper text-elli"
        onClick={e => {
          if (item.isCheck) return;
          count++;
          setTimeout(() => {
            if (count === 1) {
              // 单击
              // onSelect(item, e);
              // hasChildren && onExpand(item, e);
              // stopPropagation(e);
            } else if (count === 2) {
              // 双击
              if (item.type !== "3") {
                typeof onDoubleClick === "function" && onDoubleClick(item, e);
              }
            }
            count = 0;
          }, 300);
        }}
      >
        {title}
        {this.renderOps(item)}
      </div>
    );
    if (item.displayType == "add") {
      title = (
        <div class="wea-tree-node-wrapper">
          <WeaInput
            ecId={`${ecId}_WeaInput@wei0ss`}
            ref="input"
            style={{ width: 150 }}
            onBlur={v => this.addHandler(v, item)}
          />
        </div>
      );
    }
    if (item.displayType == "edit") {
      title = (
        <div class="wea-tree-node-wrapper">
          <WeaInput
            ref="input"
            ecId={`${ecId}_WeaInput@wimc26`}
            style={{ width: 150 }}
            value={item.name}
            onBlur={v => this.editHandler(v, item)}
          />
        </div>
      );
    }
    return title;
  }
  isCheckable(item) {
    const { props } = this;
    if (props.isCheckable) {
      return props.isCheckable(item);
    }
    return true;
  }
  isCheckboxDisable(item) {
    const { props } = this;
    if (props.isCheckboxDisable) {
      return props.isCheckboxDisable(item);
    }
    return !item.canClick || false;
  }
  isRadioDisable(item) {
    const { props } = this;
    if (props.isRadioDisable) {
      return props.isRadioDisable(item);
    }
    return !item.canClick || false;
  }
  isRadioChecked(item) {
    let bool = false;
    const { radioCheckedKey } = this.state;
    if (radioCheckedKey) {
      if (isString(radioCheckedKey)) {
        bool = item.id == radioCheckedKey || item.nodeid == radioCheckedKey;
      } else {
        bool =
          item.id == radioCheckedKey.id || item.nodeid == radioCheckedKey.id;
      }
    }
    return bool;
  }
  getExpandedKeys() {
    const { expandedKeys } = this.state;
    const keys = [];
    forEach(this.treeMap, (v, key) => {
      if (expandedKeys.indexOf(v.id) > -1) {
        keys.push(key);
      }
      if (expandedKeys.indexOf(v.nodeid) > -1) {
        keys.push(key);
      }
    });
    return keys;
  }
  getCheckedKeys() {
    const { checkedKeys } = this.state;
    const keys = [];
    forEach(this.treeMap, (v, key) => {
      if (checkedKeys.indexOf(v.id) > -1) {
        keys.push(key);
      }
      if (checkedKeys.indexOf(v.nodeid) > -1) {
        keys.push(key);
      }
    });
    return keys;
  }
  getSelectedKeys() {
    const { checkable, hasRadio } = this.props;
    if (checkable || hasRadio) return [];
    const { selectedKeys } = this.state;
    const keys = [];
    forEach(this.treeMap, (v, key) => {
      if (selectedKeys.indexOf(v.id) > -1) {
        keys.push(key);
      }
      if (selectedKeys.indexOf(v.nodeid) > -1) {
        keys.push(key);
      }
    });
    return keys;
  }
  renderNode(obj, parentObj, level) {
    const { props } = this;
    if (obj.deleted) return;
    obj.nodeid = obj.nodeid || obj.domid;
    if (props.rowKey) {
      obj.nodeid = obj[props.rowKey];
    }
    if (props.renderNodeId) obj.nodeid = props.renderNodeId(obj);
    obj.id = obj.id || obj.key;

    // 生成随机值key
    obj.treeKey = `${obj.nodeid || obj.id}__${random(1000)}`;

    //判断节点层级
    if (parentObj) {
      obj.parentTreeKey = parentObj.treeKey;
      obj.treeKey = `${obj.parentTreeKey}-${obj.treeKey}`;
    } else {
      obj.isRoot = true;
    }
    if (!this.treeMap[obj.treeKey] && obj.displayType !== "add") {
      this.treeMap[obj.treeKey] = obj;
    }
    if (!isEmpty(obj.childs)) {
      obj.children = obj.childs;
    }
    if (!isEmpty(obj.subs)) {
      obj.children = obj.subs;
    }
    if ((obj.isParent || obj.haschild) && !isEmpty(obj.children)) {
      obj.isLoad = true;
    }
    let isLeaf = true;
    if (obj.isParent || obj.haschild) isLeaf = false;
    return (
      <TreeNode
        {...obj}
        level={level}
        browserTree={true}
        title={this.renderTitle(obj)}
        key={obj.treeKey}
        isLeaf={isLeaf}
        checkable={this.isCheckable(obj)}
        disableCheckbox={this.isCheckboxDisable(obj)}
        disableRadio={this.isRadioDisable(obj)}
        radioChecked={this.isRadioChecked(obj)}
        data={obj}
        ecId={`${props.ecId}_TreeNode@zg54nd`}
      >
        {obj.children &&
          obj.children
            .map(chObj => {
              return this.renderNode(chObj, obj, level + 1);
            })
            .filter(v => !!v)}
      </TreeNode>
    );
  }

  onAccountBtnClick() {
    const { isAccount } = state;
    this.setState({ isAccount: !isAccount }, () => {
      this.props.onAccountBtnClick &&
        this.onAccountBtnClick(this.state.isAccount);
    });
  }

  render() {
    const { state, props } = this;
    const { checkStrictly, isAccount } = state;
    this.treeMap = {};
    const treeNodes =
      state.datas &&
      state.datas
        .map(obj => {
          return this.renderNode(obj, null, 0);
        })
        .filter(v => !!v);
    return (
      <Spin ecId={`${props.ecId}_Spin@i37tzj`} spinning={state.spinning}>
        {props.showCheckStrictly && (
          <Button
            ecId={`${props.ecId}_Button@qtpn7f`}
            size="small"
            className="wea-tree-strictlybtn"
            onClick={() => {
              props.onCheckStrictlyChange &&
                props.onCheckStrictlyChange(!checkStrictly);
              this.setState({ checkStrictly: !checkStrictly }, () => {
                if (!this.state.checkStrictly) {
                  let _checkedKeys = this.refs.weaTree.refs.rcTree.checkedKeys;
                  if (Array.isArray(_checkedKeys)) {
                    _checkedKeys = _checkedKeys.slice();
                    this.onCheck(_checkedKeys);
                  }
                }
              });
            }}
            title={props.checkStrictlyTitle || getLabel("128725", "包含下级")}
          >
            <span>
              {!checkStrictly ? (
                <i
                  className="icon-coms-DisplaySubordinates"
                  style={{ color: "#2db7f5" }}
                />
              ) : (
                <i className="icon-coms-NoDisplayOfSubordinates" />
              )}
            </span>
          </Button>
        )}
        {props.showIsAccount && (
          <Button
            ecId={`${props.ecId}_Button@dkb29n`}
            size="small"
            onClick={this.onAccountBtnClick.bind(this)}
            title={
              isAccount
                ? getLabel(385568, "隐藏无账号人员")
                : getLabel(31504, "显示无账号人员")
            }
          >
            <span>
              {isAccount ? (
                <i
                  className="icon-coms-ShowNoAccount"
                  style={{ color: "#2db7f5" }}
                />
              ) : (
                <i className="icon-coms-NoAccountNoDisplay" />
              )}
            </span>
          </Button>
        )}
        <Tree
          {...props}
          ecId={`${props.ecId}_Tree@8c59ph`}
          ref="weaTree"
          className={`${props.className || ""} wea-tree`}
          needExpandChildren
          clickNodeExpandChildren={!props.hasRadio && !props.checkable}
          multiple={props.checkable}
          checkable={props.checkable}
          checkStrictly={checkStrictly}
          expandedKeys={this.getExpandedKeys()} //展开受控
          checkedKeys={this.getCheckedKeys()} //选中受控
          selectedKeys={this.getSelectedKeys()} //点击受控
          onExpand={this.onExpand}
          onSelect={this.onSelect}
          onCheck={this.onCheck}
          onRadioCheck={this.onRadioCheck}
          // onDoubleClick={this.onDoubleClick}
          onDrop={this.onDrop}
          loadData={props.loadAll ? null : this.loadData}
        >
          {treeNodes}
        </Tree>
      </Spin>
    );
  }
}

const Com = middleware(WeaTree, "WeaTree");
export default Com;



// WEBPACK FOOTER //
// ./ecology9/wea-tree/index.js